import React from 'react';
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from 'react-places-autocomplete';

import { TextValidator} from 'react-material-ui-form-validator';
import CssBaseline from '@material-ui/core/CssBaseline';
import FormControl from '@material-ui/core/FormControl';
import IconButton from '@material-ui/core/IconButton';
import FileCopyIcon from '@material-ui/icons/FileCopy';

import {CopyToClipboard} from 'react-copy-to-clipboard';
import {connect} from "react-redux";
import * as actionCreators from "../../actions/actionCreators";

class LocationSearchInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      address: "",
      copied: false,
    };
  }

  handleChange = address => {
    this.setState({ address });
  };

  componentWillReceiveProps(nextProps) {
    this.setState({ address: nextProps.address });
  }

    componentWillMount() {
        this.setState({ address: this.props.address });
    }

  handleSelect = address => {
    geocodeByAddress(address)
      .then(results => getLatLng(results[0]))
      .then(latLng => {
        if(this.props.merge){
          this.props.handleInputChange({target: {name:this.props.name, address: address, latitude: latLng.lat, longitude: latLng.lng}})
        }else{
          this.props.handleInputChange({target: {name:(this.props.name ? this.props.name : "address"), value: address}})
          this.props.handleInputChange({target: {name:"latitude", value: latLng.lat}})
          this.props.handleInputChange({target: {name:"longitude", value: latLng.lng}})
        }
      })
      .catch(error => console.error('Error', error));
    this.setState({ address });
  };

  render() {
    const _this = this;
    const { displaySnackbar, closeSnackbar } = this.props;

    return (
      <React.Fragment>
      <CssBaseline />
      <PlacesAutocomplete
        value={this.state.address}
        onChange={this.handleChange}
        onSelect={this.handleSelect}
      >
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
          <FormControl margin="normal" required fullWidth>
            <div style={{display: "flex"}}>
              <TextValidator
                  style={{width: "100%"}}
                  label={_this.props.label ? _this.props.label : "Adresse"}
                  name={_this.props.name ? _this.props.name : "Adresse"}
                  validators={['required']}
                  errorMessages={['ce champ est requis']}
                  {...getInputProps({
                    placeholder: 'Recherche ...',
                    className: 'location-search-input',
                  })}
              />
              <CopyToClipboard text={this.state.address}
                               onCopy={() => this.setState({copied: true}, () => {
                                 displaySnackbar("success", "Copié", true);
                                 setTimeout(closeSnackbar, 3000)
                               })}>
                <IconButton aria-label="Copy">
                  <FileCopyIcon />
                </IconButton>
              </CopyToClipboard>

            </div>
            <div className="autocomplete-dropdown-container">
              {loading && <div>Chargement...</div>}
              {suggestions.map(suggestion => {
                const className = suggestion.active
                  ? 'suggestion-item--active'
                  : 'suggestion-item';
                // inline style for demonstration purpose
                const style = suggestion.active
                  ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                  : { backgroundColor: '#ffffff', cursor: 'pointer' };
                return (
                  <div
                    {...getSuggestionItemProps(suggestion, {
                      className,
                      style,
                    })}
                  >
                    <span>{suggestion.description}</span>
                  </div>
                );
              })}
            </div>
          </FormControl>
        )}
      </PlacesAutocomplete>
    </React.Fragment>
    );
  }
}

const mapStateToProps=(state)=>{
  return state
};

export default connect (mapStateToProps, actionCreators)(LocationSearchInput);



// WEBPACK FOOTER //
// ./src/component/utils/LocationSearchInput.js